export enum AppleSignInScope {
  FULLNAME = 0,
  EMAIL = 1,
}
